import '../radar/styles/radar-tokens.css'

interface GlassTooltipProps {
  children: React.ReactNode
  content: React.ReactNode
  position?: 'top' | 'bottom'
}

export function GlassTooltip({ children, content, position = 'top' }: GlassTooltipProps) {
  const positionClass = position === 'top'
    ? 'bottom-full left-1/2 -translate-x-1/2 mb-2'
    : 'top-full left-1/2 -translate-x-1/2 mt-2'

  return (
    <span className="relative inline-block group">
      {children}
      <span
        className={`absolute ${positionClass} z-50 pointer-events-none opacity-0 scale-95 group-hover:opacity-100 group-hover:scale-100 transition-all duration-200 max-w-xs`}
        style={{
          background: 'var(--glass-tooltip-bg)',
          backdropFilter: 'blur(var(--glass-tooltip-blur))',
          WebkitBackdropFilter: 'blur(var(--glass-tooltip-blur))',
          border: '1px solid var(--glass-tooltip-border)',
          boxShadow: 'var(--glass-tooltip-shadow)',
          borderRadius: '12px',
          padding: '12px',
        }}
      >
        <span className="block text-white text-xs leading-relaxed text-left break-words">
          {content}
        </span>
      </span>
    </span>
  )
}
